module.exports = __webpack_public_path__ + "6b25e25b4acb8576c59c096874c9a125.svg";